<template>
  <RootModalComponent
    :name="$MODAL_NAME.EDIT_ROUTE"
    icon="ri-route-line"
    :title="'route_editing' | translate"
    width="600"
    :footer="modalFooter"
    @save="save"
    @cancel="cancel"
    @beforeOpen="beforeOpen"
    @closed="closed"
    :mobile-type="$MODAL_TYPE_MOBILE.FULL"
    :frame="true"
  >
    <div class="edit-route-modal">
      <div class="edit-route-modal__inner">
        <div v-if="routesLoading" class="edit-route-modal__loader">
          <div class="edit-route-modal__spinner" />
        </div>
        <div v-else class="routes-container">
          <div class="edit-route-modal__type-route">
            <Checkbox
              :size="24"
              :value="typeRoute === 1"
              @input="updateTypeRoute"
            />
            <span class="edit-route-modal__type-route-label">{{ 'route_random' | translate }}</span>
          </div>
          <div class="route-container-title">
            <span>{{ 'start' | translate }}</span> <span>{{ 'finish' | translate }}</span>
          </div>
          <div
            v-for="window in windows"
            :key="window.id"
            class="route-item"
          >
            <div class="window-container">
              <Checkbox
                :size="24"
                :value="windowFormData[window.id].disabled"
                @input="updateWindowDisabled(window.id, $event)"
              />

              <div
                class="window-title"
                :class="{ 'route': !windowFormData[window.id].disabled }"
              >
                {{ getWindowTypeLabel(window.type) }} {{ window.number }}
              </div>
            </div>

            <div
              v-if="windowFormData[window.id].disabled"
              class="control-container"
            >
              <input
                class="route-input"
                type="text"
                maxlength="2"
                :value="windowFormData[window.id].order"
                :disabled="typeRoute === 1"
                @input="updateWindowOrder(window.id, $event.target.value)"
              />
              <Checkbox
                :size="24"
                :value="windowFormData[window.id].start"
                @input="updateWindowStart(window.id, $event)"
              />
              <Checkbox
                :size="24"
                :value="windowFormData[window.id].finish"
                @input="updateWindowFinish(window.id, $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </RootModalComponent>
</template>

<script>
import RootModalComponent from './RootModalComponent'
import Checkbox from '../controls/Checkbox'

export default {
  components: {
    RootModalComponent,
    Checkbox
  },
  data() {
    return {
      routesLoading: false,
      ticketId: null,
      windowId: null,
      typeRoute: 0,
      typeRoutes: [],
      windows: [],
      windowFormData: {},
      modalFooter: {
        lineTop: true,
        items: [
          {
            type: 'secondary',
            action: 'cancel',
            title: 'd_ws_button_cancel',
            close: true
          },
          {
            type: 'primary',
            action: 'save',
            title: 'save',
            close: false
          }
        ]
      }
    }
  },
  methods: {
    beforeOpen() {
      this.ticketId = this.$store.currentTicket ? this.$store.currentTicket.id : null;
      this.windowId = this.$store.deviceStartData && this.$store.deviceStartData.window_id 
        ? this.$store.deviceStartData.window_id 
        : null;
    
      this.loadRoutes();
    },
    loadRoutes() {
      if (!this.ticketId) {
        console.warn('Ticket ID is not available');
        return;
      }

      const params = {
        ticket_id: this.ticketId
      };
      
      if (this.windowId) {
        params.window_id = this.windowId;
      }

      this.routesLoading = true;
      this.$crudService.get('tickets/get_routes', params)
        .then((response) => {
          const data = response.data;
          this.typeRoutes = data.type_routes || [];
          this.typeRoute = data.type_route !== undefined && data.type_route !== null ? Number(data.type_route) : 0;
          this.windows = data.windows || [];
          const routes = data.routes || [];

          // Группируем маршруты по window_id (может быть несколько объектов с одинаковым window_id)
          const routesByWindowId = {};
          routes.forEach((route) => {
            if (!routesByWindowId[route.window_id]) {
              routesByWindowId[route.window_id] = [];
            }
            routesByWindowId[route.window_id].push(route);
          });

          this.windowFormData = {};
          this.windows.forEach((window) => {
            const windowRoutes = routesByWindowId[window.id] || [];
            const inRoute = windowRoutes.length > 0;
            
            if (inRoute) {
              // Объединяем значения из всех маршрутов с одинаковым window_id:
              // start = true если хотя бы в одном start: true
              // finish = true если хотя бы в одном finish: true
              // order берём из первого попавшегося
              const mergedRoute = {
                start: windowRoutes.some(r => !!r.start),
                finish: windowRoutes.some(r => !!r.finish),
                order: (windowRoutes[0] && windowRoutes[0].order) || 0
              };
              
              this.$set(this.windowFormData, window.id, {
                disabled: true,
                order: String(mergedRoute.order),
                start: mergedRoute.start,
                finish: mergedRoute.finish
              });
            } else {
              this.$set(this.windowFormData, window.id, {
                disabled: false,
                order: '',
                start: false,
                finish: false
              });
            }
          });
        })
        .catch((error) => {
          console.error('Error loading routes:', error);
        })
        .finally(() => {
          this.routesLoading = false;
        });
    },
    getWindowTypeLabel(type) {
      return this.$options.filters.translate(`window_type_${type}`) || type;
    },
    updateWindowDisabled(windowId, value) {
      this.$set(this.windowFormData[windowId], 'disabled', value);
      if (value) {
        const formData = this.windowFormData[windowId];
        const current = formData && formData.order;
        if (current === '' || current === undefined) {
          this.$set(this.windowFormData[windowId], 'order', '0');
        }
      }
    },
    updateWindowOrder(windowId, value) {
      const numericValue = value.replace(/\D/g, '');
      this.$set(this.windowFormData[windowId], 'order', numericValue);
    },
    updateWindowStart(windowId, value) {
      this.$set(this.windowFormData[windowId], 'start', value);
    },
    updateWindowFinish(windowId, value) {
      this.$set(this.windowFormData[windowId], 'finish', value);
    },
    updateTypeRoute(value) {
      this.typeRoute = value ? 1 : 0;
    },
    cancel() {
      this.$modal.hide(this.$MODAL_NAME.EDIT_ROUTE);
    },
    closed() {
      this.$modal.hide(this.$MODAL_NAME.EDIT_ROUTE);
    },
    save() {
      const routes = this.windows
        .filter((window) => {
          const formData = this.windowFormData[window.id];
          return formData && formData.disabled;
        })
        .map((window) => {
          const formData = this.windowFormData[window.id];

          return {
            office_id: window.office_id,
            window_id: window.id,
            type: window.type,
            number: window.number,
            is_online: !!window.is_online,
            order: Number(formData.order) || 0,
            start: !!formData.start,
            finish: !!formData.finish,
            issuing_point: !!window.issuing_point
          };
        });

      const payload = {
        type_route: Number(this.typeRoute) === 0 ? 0 : 1,
        window_id: this.windowId,
        ticket_id: this.ticketId,
        routes
      };

      this.$crudService.post('tickets/set_routes', payload)
        .then(() => {
          this.$modal.hide(this.$MODAL_NAME.EDIT_ROUTE);
        })
        .catch((err) => {
          console.error('Error saving routes:', err);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-route-modal {
  &__inner {
    padding: 24px 30px 24px 40px;
    max-width: 100%;
    position: relative;
    min-height: 500px;
  }

  &__type-route {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 0;
  }

  &__type-route-label {
    margin-left: 9px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--label-primary);
  }

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
  }

  &__spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--grey-04);
    border-top-color: var(--accent-blue);
    border-radius: 50%;
    animation: edit-route-spin 0.8s linear infinite;
  }
}

@keyframes edit-route-spin {
  to {
    transform: rotate(360deg);
  }
}

.routes-container {
  padding: 0 10px 0 10px;
  margin-top: -8px;
  max-height: 550px;
  overflow-y: auto;

  .route-item {
    height: 32px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    & > div {
      display: flex;
      align-items: center;
    }
  }

  .window-container {
    display: flex;
    align-items: center;
    min-width: 0;

    .window-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 9px;
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: var(--label-primary);

      &.route {
        color: var(--accent-pink);
      }
    }
  }

  .control-container {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .route-input {
    width: 45px;
    height: 32px;
    padding: 0 8px;
    border: 1px solid var(--grey-04);
    border-radius: 3px;
    font-size: 14px;
    text-align: center;
    color: var(--label-primary);
    background: var(--light-01);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
      border-color: var(--accent-blue);
    }
  }
}

.route-container-title {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;

  span {
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--label-secondary);
    
    &:first-child {
      margin-left: 0;
    }
  }
}

@media (max-width: 425px) {
  .edit-route-modal {
    &__inner {
      padding: 18px 16px;
    }

    &__type-route {
      padding-left: 0;
    }
  }

  .routes-container {
    padding: 0;
    
    .control-container {
      gap: 16px;
    }
    
    .route-input {
      width: 40px;
    }
  }
  
  .route-container-title {
    padding-right: 0;
  }
}
</style>
